import { createAsyncThunk } from "@reduxjs/toolkit";
import coreAPIs from "services/api/core";

export const getCoreFields = createAsyncThunk("core/fields/getCoreFields", async (payload) => {
  try {
    const response = await coreAPIs.getCoreFields(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error?.response?.data?.error || error;
  }
});

export const createCoreField = createAsyncThunk("core/fields/createCoreField", async (payload) => {
  try {
    const response = await coreAPIs.createCoreField(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error?.response?.data?.error || error;
  }
});

export const updateCoreField = createAsyncThunk("core/fields/updateCoreField", async (payload) => {
  try {
    const response = await coreAPIs.updateCoreField(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error?.response?.data?.error || error;
  }
});
